import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatasetBrowserData, Pagination } from '@mode/shared/contract-common';
import { SelectionModel } from '@angular/cdk/collections';
import { PaginationViewComponent, TimeAgoPipe } from '@mode/shared/ui';
import { IconComponent, TooltipDirective } from '@mode/capra';
import { CdkTableModule } from '@angular/cdk/table';
import { ReactiveFormsModule } from '@angular/forms';
import { getInitialFlagValue } from '@mode/shared/util-js';
import { FeatureFlag } from '@mode/shared/contract-common';

@Component({
  selector: 'mode-dataset-search-data-table',
  standalone: true,
  imports: [
    CommonModule,
    TimeAgoPipe,
    IconComponent,
    PaginationViewComponent,
    CdkTableModule,
    TooltipDirective,
    ReactiveFormsModule,
  ],
  templateUrl: './dataset-search-data-table.component.html',
  styleUrls: ['./dataset-search-data-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatasetSearchDataTableComponent {
  @Input() dataSource: DatasetBrowserData[] = [];
  @Input() datasetsPagination!: Pagination;
  @Output() selectDataset = new EventEmitter<DatasetBrowserData>();
  @Output() changeCurrentPage = new EventEmitter<number>();
  @Input() displayedColumns: string[] = ['name', 'description', 'collection', 'creator', 'lastRefreshed'];
  selectedRow = new SelectionModel<DatasetBrowserData>(false, []);
  selectedDataset?: DatasetBrowserData;
  toolTipEnabled = false;
  enableDatasetsPagination = getInitialFlagValue(FeatureFlag.ShowDatasetsPagination);

  selectDatasetItem(element: DatasetBrowserData) {
    this.selectDataset.emit(element);
    this.selectedRow.toggle(element);
    this.selectedDataset = element;
  }

  handleChangeCurrentPage(newPageNumber: number) {
    this.changeCurrentPage.emit(newPageNumber);
  }

  enableToolTipControl(event: any) {
    if (event.target.offsetWidth < event.target.scrollWidth) {
      this.toolTipEnabled = true;
    }
  }
  hideToolTipControl() {
    this.toolTipEnabled = false;
  }
}
